import { z } from 'zod';

import { request } from '@/api/httpClient';

const recipientSchema = z.object({
  id: z.number(),
  client_id: z.number(),
  client_name: z.string(),
  phone: z.string().nullable(),
  status: z.string(),
  error_message: z.string().nullable(),
  sent_at: z.string().nullable(),
});

const campaignSchema = z.object({
  id: z.number(),
  message: z.string(),
  status: z.string(),
  created_at: z.string().nullable(),
  updated_at: z.string().nullable(),
  sent_at: z.string().nullable(),
  recipients: z.array(recipientSchema),
});

export type SmsCampaign = z.infer<typeof campaignSchema>;

export async function getSmsCampaign(id: number): Promise<SmsCampaign> {
  return campaignSchema.parse(await request<unknown>(`/v2/sms-campaigns/${id}`));
}

export async function saveSmsCampaign(message: string, clientIds: number[], id?: number) {
  return campaignSchema.parse(
    await request<unknown>(`/v2/sms-campaigns${id ? `/${id}` : ''}`, {
      method: id ? 'PUT' : 'POST',
      body: { message, client_ids: clientIds },
    }),
  );
}

export async function sendSmsCampaign(id: number) {
  return campaignSchema.parse(
    await request<unknown>(`/v2/sms-campaigns/${id}/send`, { method: 'POST' }),
  );
}
